var rich_content_viewer_default = {
  "fontElementMap": "_9pFAe",
  "wrapper": "kF1Yq",
  "pluginContainerMobile": "BsyJS",
  "viewer": "uoKII",
  "android": "_1Kb8T",
  "rootedTraversedContent": "_4XU5A",
  "atomic": "mAaCB",
  "toolbar": "PPK8e",
  "block": "esTdg"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
